import { FC, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import SectionLayout from 'components/shared/SectionLayout';
import InsightsLiteTopBar from 'app/modules/insightsLite/components/InsightsLiteTopBar';
import InsightsLiteContent from 'app/modules/insightsLite/components/InsightsLiteContent';
import Container from 'components/insights/Container';
import { createInsightsApolloClient } from 'app/modules/insights/utils/createAuthorizedInsightsApolloClient';
import { useApp } from 'modules/app/appSelector';
import ModalRoute from 'context/ModalRouter';
import { modalRoutes } from 'constants/routes';
import { InsightsAddNewProfileModal } from 'app/modules/insights/components/modals/InsightsAddNewProfileModal';
import AnalyticsViewSwitcher from 'app/modules/insights/components/AnalyticsViewSwitcher';

type Props = {};

const InsightsLite: FC<Props> = () => {
  const { authToken } = useApp();
  const [client] = useState(() =>
    createInsightsApolloClient(authToken as string),
  );

  return (
    <ApolloProvider client={client}>
      <Container>
        <SectionLayout
          header={
            <>
              <InsightsLiteTopBar />
              <div className="tw-mt-6 tw-flex tw-w-full tw-justify-end tw-px-6">
                <AnalyticsViewSwitcher />
              </div>
            </>
          }
          main={<InsightsLiteContent />}
          mainProps={{
            className: 'tw-flex-1 !tw-px-4 !tw-py-6',
          }}
        />
        <ModalRoute
          component={InsightsAddNewProfileModal}
          path={modalRoutes.NEW_PROFILE}
        />
      </Container>
    </ApolloProvider>
  );
};

export default InsightsLite;
